var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.debug === 'true' || _vm.debug === true)?_c('span',[_vm._v(_vm._s(_vm.version))]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm._f("formatoFecha")(_vm.data['item'][_vm.data.field.key])))])])}
var staticRenderFns = []

export { render, staticRenderFns }